import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18N from 'vuex-i18n'

import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'
import setupI18N from '@/i18n'
import moment from 'moment'

Vue.use(Vuex)

const state = {
  loggedUser: {},
  timeNow: moment().utc(true),
  workers: [],
  users: [],
  operators: [],
  notifiers: [],
  currentTicket: {},
  currentUser: undefined,
  currentTickets: [],
  ticketsWaitingCount: {},
  nextTicket: {},
  nextTickets: [],
  user: {},
  devices: [],
  service: undefined,
  news: [
    {
      id: -1,
      title: 'São disponibilizadas aos alunos do Técnico bolsas de investigação em diversos domínios científicos',
      content: 'São disponibilizadas aos alunos do Técnico bolsas de investigação em diversos domínios científicos'
    }
  ]
}

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})

Vue.use(VuexI18N.plugin, store)
setupI18N(Vue)

export default store
